import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import { Column } from '@nirvana/shared/dtos/types/shared/filters';
import { GetRowsRequest, GetSummaryRequest, GetSummaryResponse } from '../../../grid/types/common';
import { ColumnKeys } from '../types';
import { convertGridFiltersToExtJsFilters } from '../../../grid/utils/filters';
import { handleComplexEnumFilter } from '../../common/utils';

/**
 * Data provider specific for grid component only
 */
export class VulnerabilitiesAppGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  response;
  dependencies;

  constructor(dependencies) {
    super();
    this.dependencies = dependencies;
  }

  async getSummary(request: GetSummaryRequest<ColumnKeys>): Promise<GetSummaryResponse> {
    let response = this.response;

    // if you change something here, change in handleCSVExportEvent in controller too
    let filters: any[] = convertGridFiltersToExtJsFilters(request.filters);
    const complexEnumFilterColumns = [ColumnKeys.NAME, ColumnKeys.CVES, ColumnKeys.AFFECTED_DEVICES];
    filters = handleComplexEnumFilter(complexEnumFilterColumns, filters);

    if (!response) {
      response = await this.dependencies.api.clients.Vulnerabilities.readRecords(request, filters).toPromise();
      this.response = response;
    }

    const summary: any = {
      summary: `${response.total} items`,
      numItems: response.total,
    };

    if (response.extraDetails) {
      summary.extraDetails = response.extraDetails;
    }

    return summary;
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    if (!this.response) {
      return { rawEvents: [] };
    }

    const response = this.response;
    this.response = null;

    return { rawEvents: response.data };
  }
}
